import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, Optional } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { en_US, NZ_I18N, NzI18nService } from 'ng-zorro-antd/i18n';

import { UiIconsModule } from 'ui-icons';

type Value = unknown;

@Component({
  selector: 'ui-platform-rangepicker',
  templateUrl: './rangepicker.component.html',
  styleUrl: './rangepicker.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    NzDatePickerModule,
    FormsModule,
    UiIconsModule,
    ReactiveFormsModule
  ],
  providers: [
    { provide: NZ_I18N, useValue: en_US },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiPlatformRangepickerComponent),
      multi: true
    }
  ]
})
export class UiPlatformRangepickerComponent implements ControlValueAccessor {
  @Optional() @Input() disabled = false;
  @Optional() @Input() label = '';
  internalValue: Value = null;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private i18n: NzI18nService
  ) {
    this.i18n.setLocale(en_US);
  }

  syncExternalValue: (value: Value) => void = () => {};
  syncExternalTouched: () => void = () => {};

  onModelChange(value: Value) {
    this.syncExternalValue(value);
    this.syncExternalTouched();
  }

  writeValue(value: Value) {
    this.internalValue = value;
    this.changeDetectorRef.detectChanges();
  }

  registerOnChange(fn: (value: Value) => void) {
    this.syncExternalValue = (value: Value) => {
      fn(value);
    };
  }

  registerOnTouched(fn: () => void) {
    this.syncExternalTouched = () => {
      fn();
    };
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.changeDetectorRef.detectChanges();
  }
}
